import React, { useState } from "react";
import { Box, Heading, RadioGroup, Radio, Stack } from "@chakra-ui/react";
import EmbedBody from "./EmbedBody";
const Sidebar = () => {
	const [embedtype, setEmbedtype] = useState("shortcode");
	return (
		<Box w="30%" minH="500px" bg="background.secondary" p="1rem">
			<Heading as="h6" size="xs" textTransform="uppercase">
				Embed form in page using
			</Heading>
			<Box mt="2rem">
				<RadioGroup onChange={setEmbedtype} value={embedtype}>
					<Stack direction="row">
						<Radio value="freshworks">Freshworks form block</Radio>
						<Radio value="shortcode">Shortcode</Radio>
					</Stack>
				</RadioGroup>
			</Box>
			<EmbedBody embedType={embedtype} />
		</Box>
	);
};

export default Sidebar;
